
import React from "react";
import { User, Shield } from "lucide-react";
import { cn } from "@/lib/utils";

interface RoleAvatarProps {
  role: "admin" | "ouvrier";
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

export const RoleAvatar: React.FC<RoleAvatarProps> = ({ 
  role, 
  size = "md", 
  className 
}) => {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-10 h-10", 
    lg: "w-12 h-12",
    xl: "w-16 h-16"
  };

  const iconSizes = {
    sm: 16,
    md: 20,
    lg: 24,
    xl: 32
  };

  const bgColor = role === "admin" ? "bg-blue-500" : "bg-red-500";
  const Icon = role === "admin" ? Shield : User;

  return (
    <div className={cn(
      "rounded-full flex items-center justify-center text-white",
      bgColor,
      sizeClasses[size],
      className
    )}>
      <Icon size={iconSizes[size]} />
    </div>
  );
};
